import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { routeMap } from 'routeMap';
import { useAuthWrapperContext } from 'toolbox/src/components/AuthWrapper/AuthWrapper';

export default function AdminOnlyRoute({ component: C, ...rest }) {
  const { groups, status } = useAuthWrapperContext();
  const isAuthenticated = status === 'loggedIn' || false;
  const isAdmin = groups?.includes('admin') || false;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated && isAdmin ? (
          <C {...props} />
        ) : (
          <Redirect to={routeMap.error({ params: { type: '403' } })} />
        )
      }
    />
  );
}
